import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicLayout from './PublicLayout';
import { AuthBannerLayout } from '../components/auth';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <PublicLayout>
      <AuthBannerLayout>{children || <Outlet />}</AuthBannerLayout>
    </PublicLayout>
  );
};

export default AuthLayout;
